import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEditPageComponent} from "./custom-object-edit-page.component";
import {MembershipTypeCustomObjectEntityModel} from "../membership-type-custom-object-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-membership-type-custom-object-edit-page",
    templateUrl: "./custom-object-edit-page.component.html",
    providers: [provideEntityModel(MembershipTypeCustomObjectEntityModel)]
})
export class MembershipTypeCustomObjectEditPageComponent extends CustomObjectEditPageComponent {
    override membershipTypeContext: boolean = true;

    constructor(model: MembershipTypeCustomObjectEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
